import { render, staticRenderFns } from "./SuggestionLine.vue?vue&type=template&id=d0b93cb0&lang=pug&"
import script from "./SuggestionLine.vue?vue&type=script&lang=js&"
export * from "./SuggestionLine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports